import request from '@/utils/request'

export function getRoleList(data) {
  return request({
    url: '/manageUser/getRole',
    method: 'get',
  })
}

export function getPermissionByRole(roleId) {
    return request({
        url: `/manageUser/getPermissionByRole/${roleId}`,
        method: 'get',
    })
}

export function getRoleDetail(roleId) {
    return request({
        url: `/manageUser/getRoleDetail/${roleId}`,
        method: 'get',
    })
}

export function deleteUser(userId) {
    return request({
        url: `/manageUser/deleteUser/${userId}`,
        method: 'delete',
    })
}


export function updateRole(data) {
    return request({
      url: '/manageUser/updateRole',
      method: 'post',
      data
    })
}

// Permissions that can be assigned to a user (excludes permissions already granted by the user's role)
export function getAssignablePermissions(userId) {
    return request({
        url: `/manageUser/getAssignablePermissions/${userId}`,
        method: 'get',
    })
}

// Permissions saved directly on the user (user_permission), separate from role_permission
export function getUserPermission(userId) {
    return request({
        url: `/manageUser/getUserPermission/${userId}`,
        method: 'get',
    })
}
